import React from 'react';
import { ContentProps } from '../../content/types';

function UnknownElement({ type }: ContentProps) {
  return (
    <div className="border border-ui-red rounded px-6 text-ui-red py-4">
      No element found in register with name <span className="font-bold">'{type}'</span>
    </div>
  );
}

export { UnknownElement };
